// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvailabilityCalendarController from "./availability_calendar_controller"
application.register("availability-calendar", AvailabilityCalendarController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import FilterDisclosureController from "./filter_disclosure_controller"
application.register("filter-disclosure", FilterDisclosureController)

import InspectionController from "./inspection_controller"
application.register("inspection", InspectionController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OnboardingGuideController from "./onboarding_guide_controller"
application.register("onboarding-guide", OnboardingGuideController)

import OnboardingSurveyController from "./onboarding_survey_controller"
application.register("onboarding-survey", OnboardingSurveyController)

import OperatorCalendarController from "./operator_calendar_controller"
application.register("operator-calendar", OperatorCalendarController)

import PriceBreakdownController from "./price_breakdown_controller"
application.register("price-breakdown", PriceBreakdownController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import StorefrontToggleController from "./storefront_toggle_controller"
application.register("storefront-toggle", StorefrontToggleController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import VehicleCatalogController from "./vehicle_catalog_controller"
application.register("vehicle-catalog", VehicleCatalogController)
